import { DealViewModel } from '@common/model/deal';
import { useModalPromise } from '@cp/shared/modal';
import { useCallback } from 'react';
import { AsyncResult, Result } from '@youhelp-ru/core';
import { DEAL_VIEW_MODAL } from '../lib/modals';

export type DealViewFeature = (dealTrigger: string | DealViewModel) => AsyncResult<void, unknown>;

export const useDealView = (): DealViewFeature => {
  const openModal = useModalPromise(DEAL_VIEW_MODAL);
  return useCallback(
    (dealTrigger) => {
      if (typeof dealTrigger !== 'string') {
        return Result.fromAsync(() => openModal({ deal: dealTrigger }));
      }

      // TODO: Provide deal id trigger
      throw new Error('Deal ID trigger not provided');
    },
    [openModal],
  );
};
